import * as S from './PageTemplate.styled';
import useNav from '../../../application/hooks/useNav';
import { AppBar } from 'oui';

interface IPageTemplate {
  children: React.ReactNode;
}

const PageTemplateLgu = (props: IPageTemplate) => {
  const { historyBack } = useNav();

  const onHandlePrevBtn = () => {
    historyBack();
  };

  return (
    <>
      <S.PageTemplate>
        <AppBar
          type={'lgu'}
          title={'대출 비교'}
          leftIcon={{
            name: 'ArrowBackSharp',
            state: 'focused',
            size: 'lg',
            color: 'black',
          }}
          onClickPrevButton={onHandlePrevBtn}
        />
        {props.children}
      </S.PageTemplate>
    </>
  );
};

export default PageTemplateLgu;
